import { render, staticRenderFns } from "./OpenManifestPage.vue?vue&type=template&id=7e4aea72&scoped=true"
import script from "./OpenManifestPage.vue?vue&type=script&lang=js"
export * from "./OpenManifestPage.vue?vue&type=script&lang=js"
import style0 from "./OpenManifestPage.vue?vue&type=style&index=0&id=7e4aea72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4aea72",
  null
  
)

export default component.exports